import { useEffect, useState } from "react";
import { copy } from "../copy";
import { ADDABLE_PLATFORMS } from "../domain/accounts";
import { useApp } from "../state/store";

export function AddAccount() {
  const app = useApp();
  const [platform, setPlatform] = useState<string>("抖音");
  const [name, setName] = useState("");
  const [url, setUrl] = useState("");
  const [note, setNote] = useState("");
  const urlOk = !url.trim() || /^https?:\/\//i.test(url.trim());

  useEffect(() => {
    const onKey = (event: KeyboardEvent) => {
      if (event.key === "Escape") app.openAddAccount(false);
    };
    const previous = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    window.addEventListener("keydown", onKey);
    return () => {
      document.body.style.overflow = previous;
      window.removeEventListener("keydown", onKey);
    };
  }, [app]);

  function submit() {
    const profile = app.addAccount({ platform, displayName: name, profileUrl: url, note });
    if (!profile) return;
    setName("");
    setUrl("");
    setNote("");
    app.openAddAccount(false);
  }

  return (
    <div className="drawer-backdrop" onMouseDown={() => app.openAddAccount(false)}>
      <div className="drawer find-sheet" role="dialog" aria-modal="true" aria-labelledby="add-account-title" onMouseDown={(event) => event.stopPropagation()}>
        <header>
          <h2 id="add-account-title">{copy.account.add}</h2>
        </header>
        <div className="drawer-body stack">
          <label>
            平台
            <select value={platform} onChange={(event) => setPlatform(event.target.value)}>
              {ADDABLE_PLATFORMS.map((item) => (
                <option key={item} value={item}>{item}</option>
              ))}
            </select>
          </label>
          <label>
            账号名称
            <input value={name} maxLength={80} onChange={(event) => setName(event.target.value)} />
          </label>
          <label>
            主页链接
            <input value={url} maxLength={500} placeholder="https://" onChange={(event) => setUrl(event.target.value)} />
          </label>
          {!urlOk ? <p className="inline-error">链接以 http:// 或 https:// 开头。</p> : null}
          <label>
            备注
            <input value={note} maxLength={500} onChange={(event) => setNote(event.target.value)} />
          </label>
        </div>
        <footer>
          <button type="button" className="button" onClick={() => app.openAddAccount(false)}>{copy.find.cancel}</button>
          <button type="button" className="button primary" onClick={submit} disabled={!name.trim() || !urlOk}>{copy.account.add}</button>
        </footer>
      </div>
    </div>
  );
}
